import React, { forwardRef, useRef, useEffect } from "react";
import makeStyles from '@mui/styles/makeStyles';
import swal from "sweetalert";
import {
  Grid,
  Checkbox,
  TextField,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";

import { ViewList } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";

import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";
/* import ProductSelectInPrescriptionModal from "../../../services/MailSMSLogModal"; */

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import Autocomplete from '@mui/material/Autocomplete';

import { getAllFacilityList } from "../../../services/Common";

import { format, subDays } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
const SMSLog = (props) => {
  const tblMenuRefHolder = useRef({ table: null });
  const tblMenuRef = tblMenuRefHolder.current;
  const { useState } = React;
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const FacilityId = localStorage.getItem("FacilityId");
  const lan = localStorage.getItem("LangCode");
  const menukey = "sms-log";
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;
  const Users_List = JSON.parse(localStorage.getItem("UserListEdit"));

  let All_UserList_label = {
    id: "0",
    name: t(DispensingLanguage[lan][menukey]["All"]),
  };
  const UserList = [All_UserList_label].concat(Users_List);

  //const Facility_List = JSON.parse(localStorage.getItem("FacilityList"));
  let All_Facility_label = {
    id: "0",
    name: t(DispensingLanguage[lan][menukey]["All"]),
  };

  const classes = useStyles();
  const tableRef = useRef();

  const [dataItems, setDataItems] = useState([]);
  const [dataItems1, setDataItems1] = useState([]);

  const [selectedRoleData, setSelectedRole] = useState(0);
  const [bFirst, setBFirst] = useState(true);

  const [isLoadingll, setLoading] = useState(true);

  const [selectedrow, setSelectedrow] = useState(false);

  const [currRequestType, setcurrRequestType] = useState(0);
  const [currEventType, setcurrEventType] = useState(0);
  const [currUserListId, setcurrUserListId] = useState(0);

  const [TableName, setTableName] = useState([
    { id: "0", name: t(DispensingLanguage[lan][menukey]["All"]) },
  ]);

  const [currRowId, setCurrRowId] = useState(0);
  const [openSqlLog, setopenSqlLog] = useState(false);

  const [LogDataArray, setLogDataArray] = useState([]);

  const handleClose = (modalname) => {
    switch (modalname) {
      case "ProductBatch":
        setopenSqlLog(false);
        break;
      case "ProductBatchOpen":
        setopenSqlLog(true);
        break;

      default:
        break;
    }
  };

  const [selectedStartDate, setSelectedStartDate] = React.useState(
    format(subDays(new Date(), 7), 'yyyy-MM-dd')
  );

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
    setLoading(true);
    setSelectedRole(0);
  };

  const [selectedEndDate, setSelectedEndDate] = React.useState(
    format(new Date(), 'yyyy-MM-dd')
  );

  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
    setLoading(true);
    setSelectedRole(0);
  };

  let params0 = {
    menukey: menukey,
    action: "getDataList",
    logStartDate: selectedStartDate,
    logEndDate: selectedEndDate,
    RequestType: currRequestType,
    EventType: currEventType,
    UserList: currUserListId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
    // FacilityId:currFacilityId
  };

  const { isLoading, error, isError, data, refetch } = useQuery(
    [params0],
    api.getSMSLogData,
    {
      onSuccess: (data) => {
        setDataItems(data);

        //setSelectedrow(true);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );

  let params3 = {
    menukey: menukey,
    action: "getEventTypeList",
  };

  const {
    isLoading3,
    error3,
    isError3,
    data: logData3,
    refetch: MenuRefetch3,
  } = useQuery([params3], api.getEventTypeList, {
    onSuccess: (logData3) => {
      let All_Facility_label = {
        id: "0",
        name: t(DispensingLanguage[lan][menukey]["All"]),
      };
      const TableList = [All_Facility_label].concat(logData3);
      setcurrEventType(0);
      setTableName(TableList);
    },
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 0, //1000 * 60 * 60 * 24,
  });

  const rowClick = (e: any, row: any) => {
    let rowData = row._row.data;
    console.log(rowData.id);
    setSelectedRole(rowData.id);
    //MenuRefetch();
  };

  const handleEventTypeChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setcurrEventType(rowId);
    setSelectedRole(0);
  };

  useEffect(() => {
    //handleClose("ProductBatchOpen");
  }, [LogDataArray]);

  const columns = [
    { title: "Id", field: "id", width: 50, visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["SL."]),
      formatter: "rownum",
      width: 60,
      hozAlign: "center",
      headerSort: false,
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Date"]),
      field: "SendTime",
      headerFilter: true,
      width: 132,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Event Type"]),
      field: "EventType",
      headerFilter: true,
       width: 130,
    },
    /* {
      title: t(DispensingLanguage[lan][menukey]["Receiver"]),
      field: "Receiver",
      headerFilter: true,
      width: 180,
      formatter: (cell) => `<div class="wrap-text">${cell.getValue()}</div>`,

    }, */
    {
      title: t(DispensingLanguage[lan][menukey]["Subject"]),
      field: "mSubject",
      headerFilter: true,
      //width: 300,
      formatter: (cell) => `<div class="wrap-text">${cell.getValue()}</div>`,

    },
     {
      title: t(DispensingLanguage[lan][menukey]["Contact No"]),
      field: "copySMSTo",
      headerFilter: true,
      width: 130,
    },
     {
      title: t(DispensingLanguage[lan][menukey]["Status"]),
      field: "SMSStatus",
      headerFilter: true,
      width: 130,
    },
   /*  {
      title: t(DispensingLanguage[lan][menukey]["DryMode"]),
      field: "DryMode",
      headerFilter: true,
      width: 100,
      hozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["TemplateMode"]),
      field: "TemplateMode",
      headerFilter: true,
      width: 130,
    }, */

    /* {
      title: "",
      headerSort: false,
      field: "custom",
      hozAlign: "center",
      width: 10,
      formatter: reactFormatter(<ShowSqlLogPopup />),
    }, */
  ];

  useEffect(() => {
    // if(selectedrow == true){
    //   tblMenuRef.table.selectRow(1);
    // }
  }, [selectedrow]);

  function ShowSqlLogPopup(props: any) {
    const rowData = props.cell._cell.row.data;

    return (
      <>
        <ViewList
          onClick={() => {
            setCurrRowId(rowData.id);
            setLogDataArray([
              rowData.LogResult,
              rowData.MailGunResponse,
              rowData.SMSResponse,
              rowData.mBody,
            ]);
            handleClose("ProductBatchOpen");
          }}
        />
      </>
    );
  }

  return (
    <>
      <div className={classes.dispenserPageTitle}>
        <div className="d-flex justify-dispenser mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {" "}
                {DispensingLanguage[lan][menukey]["SMS Log"]}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={12} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                    <DatePicker
                      inputFormat="dd/MM/yyyy"
                      label={DispensingLanguage[lan][menukey]["Log Start Date"]}
                      value={selectedStartDate}
                      onChange={handleStartDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.fullWidth}
                          id="date-picker-inline"
                        />
                      )}
                    />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                    <DatePicker
                      inputFormat="dd/MM/yyyy"
                      label={DispensingLanguage[lan][menukey]["Log End Date"]}
                      value={selectedEndDate}
                      onChange={handleEndDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.fullWidth}
                          id="date-picker-inline"
                        />
                      )}
                    />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} sm={3}>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    autoHighlight
                    id="DatabaseTables"
                    disableClearable
                    options={TableName}
                    //disabled={UserName=="admin"?false:true}
                    onChange={(event, newValue) =>
                      handleEventTypeChange(event, newValue)
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                      value={
                      (TableName.find(
                          (Table_Name) => Table_Name.id == currEventType
                        ) ?? null)
                    }
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">{option.name}</Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={DispensingLanguage[lan][menukey]["Event Type"]}
                        variant="standard"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

          <Grid container>
            <Grid item xs={12} sm={12}>
              <div className="sw_relative">
                <div className="uniqueName">
                  <ReactTabulator
                    onRef={(r) => { tblMenuRef.table = r.current; }}
                    options={{
                      selectableRows: 1,
                      selectableRowsRangeMode: "click",
                    }}
                    columns={columns}
                    data={dataItems}
                    layout={"fitColumns"}
                    height={"500px"}
                    // tooltips={true}
                    // dataTree={true}
                    events={{
                        rowClick: (e, row) => rowClick(e, row),
                      }}
                    
                  />
                </div>
              </div>
            </Grid>
          </Grid>
      </div>
    </>
  );
};

export default SMSLog;

const useStyles = makeStyles({
  dispenserPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
